export function getAttributeDefaultValue(
  attributeType: string,
): string | number | boolean | null {
  switch (attributeType) {
    case 'text':
      return null
    case 'simple-select':
      return ''
    case 'boolean':
      return false
    case 'integer':
    case 'decimal':
      return 0
    case 'image-url':
      return ''
    default:
      return ''
  }
}

export function isNumberType(type: string): boolean {
  return ['integer', 'decimal'].includes(type)
}
